import { Box, Typography, styled } from "@mui/material"
import type { TypographyProps } from "@mui/material/Typography"

const OuterImg = styled(Box)({
  position: "relative",
  width: "100%",
  height: "0",
  paddingTop: "125%",
})

const InnerImg = styled(Box)(() => ({
  position: "absolute",
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  padding: "30px",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  backgroundColor: "#f5f5f5", // theme.palette.background.neutral,
  border: `1px solid #f0f0f0`,
}))

const Container = styled(Box)({
  width: "100%",
})

const DescriptionWrapper = styled(Box)({
  marginTop: "2rem",
  position: "relative",
})

const CategoryText = styled(Typography)({
  position: "absolute",
  top: "-20px",
  left: 0,
})

const TitleText = styled(Typography)<TypographyProps>({
  fontSize: "1.125rem !important",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: "2",
  WebkitBoxOrient: "vertical",
  minHeight: "3rem",
})

function ProductCard(): JSX.Element {
  return (
    <Container>
      <OuterImg>
        <InnerImg></InnerImg>
      </OuterImg>

      <DescriptionWrapper>
        <CategoryText variant="body2"></CategoryText>
        <TitleText variant="h6" component="h2"></TitleText>
      </DescriptionWrapper>
    </Container>
  )
}

export default ProductCard
